{
  "addons.addonList": "Листа додатака",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Креирајте и преузмите свој АПИ кључ са ове везе",
  "addons.ambientWeatherDescription": "Ambient метеостанице (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "АПИ кључ",
  "addons.applicationKey": "Кључ апликације",
  "addons.connect": "Повежи",
  "addons.davisApiSecret": "API тајни",
  "addons.davisApiV2Key": "V2 API кључ",
  "addons.davisDescription": "Davis метеостанице  (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Прибавите ваш V2 API кључ са овог линка",
  "addons.disconnect": "Прекини везу",
  "addons.ecowittCreateAndRetrieveKeys": "Направите и преузмите свој АПИ кључ и кључ апликације са ове везе",
  "addons.ecowittDescription": "Ецовитт нуди професионалне метеоролошке станице, бежичне унутрашње/спољашње термометре, прецизне кишомере, сензоре квалитета ваздуха и још много тога.",
  "addons.helpLink": "Како повезати {provider}",
  "addons.myAcuriteAccountOnHold": "Ваш налог је стављен на чекање. Унесите лозинку да бисте поново повезали свој налог",
  "addons.myAcuriteDescription": "АцуРите је бренд метеоролошке станице број 1 у Северној Америци. Као лидер у технологији времена, температуре и временских прилика, АцуРите вам пружа детаљне информације о вашем унутрашњем и спољашњем окружењу тако да можете са поверењем да планирате свој дан.",
  "addons.myAcuriteEnterCredentials": "Унесите своје Ми АцуРите акредитиве да бисте повезали свој Ми АцуРите налог са СмартМикин-ом",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Да промените температуру у кући, било из кревете било са друге стране света, користите ваш Нетатмо Термостат.",
  "addons.netatmoThermostat": "Нетатмо Термостат",
  "addons.netatmoWeather": "Нетатмо Метеостаница",
  "addons.netatmoWeatherDescription": "Ваша лична метеоролошка станица",
  "addons.or": "или",
  "addons.providerAccountDisconnected": "Веза са вашом метеоролошком службом је истекла. Поново се повежите да бисте наставили ажурирање података.",
  "addons.reconnect": "Повежи поново",
  "addons.weatherflowCreateToken": "Направи и повуци токен са овог линка",
  "addons.weatherflowTempestDescription": "Tempest метеосистем са уграђеним сензором вјетра, сензором кише",
  "addons.wundergroundApiKey": "АПИ кључ",
  "addons.wundergroundDescription": "Веатхер Ундергроунд је глобална заједница људи која повезује податке са сензора животне средине као што су метеоролошке станице и монитори квалитета ваздуха како бисмо могли да испоручимо богате, хиперлокалне податке који су вам потребни за подстицање ваших страсти.",
  "addons.wundergroundRetrieveApiKey": "Преузмите свој АПИ кључ са ове везе",
  "addons.wundergroundRetrieveStationId": "Преузмите идентификатор своје станице (ИД) са ове везе",
  "addons.wundergroundStationId": "ИД станице",
  "airQuality.airQuality": "Квалитет ваздуха",
  "airQuality.airQualityIndex": "Индекс квалитета ваздуха",
  "airQuality.co": "Угљен моноксид",
  "airQuality.good": "Добро",
  "airQuality.goodDescription": "Квалитет ваздуха је задовољавајући и загађеност ваздуха представља малу опасност.",
  "airQuality.hazardous": "Опасно",
  "airQuality.hazardousDescription": "Здравствено упозорење: све особе су под ризиком озбиљних здравствених симптома.",
  "airQuality.indoorAirQuality": "Квалитет ваздуха у затвореном простору",
  "airQuality.moderate": "Умерено",
  "airQuality.moderateDescription": "Квалитет ваздуха је прихватљив; ипак мањем броју људи који су изразито осетљиви на загађење ваздуха, поједини полутанти могу изазвати тегобе",
  "airQuality.no2": "Азот диоксид",
  "airQuality.o3": "Озон",
  "airQuality.pm10": "Честице пречника 10 μm или мање",
  "airQuality.pm25": "Честице пречника 2.5 μm или мање",
  "airQuality.sensitiveUnhealthy": "Осетљиве особе су угрожене",
  "airQuality.sensitiveUnhealthyDescription": "Јако осетљиве особе могу осетити тегобе. Просечна здрава особа неће имати проблем.",
  "airQuality.so2": "Сумпор диоксид",
  "airQuality.unhealthy": "Нездраво",
  "airQuality.unhealthyDescription": "Сви ће да осете тегобе. Јако осетљиве особе могу да имају израженије симптоме.",
  "airQuality.veryUnhealthy": "Веома нездраво",
  "airQuality.veryUnhealthyDezscription": "Упозорење на повећани ризик. Све особе ће вероватно осетити симптоме.",
  "alerts.addAlert": "Додај обавештење",
  "alerts.addCondition": "Додај услов",
  "alerts.alertAdded": "Обавештење успешно додато",
  "alerts.alertAuthorizationNotice": "Обавештења ће да раде само ако овластите Smartmixin да приказује обавештења",
  "alerts.alertDeleted": "Обавештење успешно обрисано",
  "alerts.alertEdited": "Обавештење успешно обрисано",
  "alerts.alertName": "Назив обавештења",
  "alerts.alertWhen": "Желим да будем обавештен кад:",
  "alerts.aqiGreaterThan": "AQI већи од",
  "alerts.aqiGreaterThanThreshold": "AQI већи од {value}{unit}",
  "alerts.aqiLessThan": "AQI мањи од",
  "alerts.aqiLessThanThreshold": "AQI мањи од {value}{unit}",
  "alerts.atLeastOneCondition": "Морате додати барем један услов",
  "alerts.co2GreaterThan": "Концентрација CO2 већа од",
  "alerts.co2GreaterThanThreshold": "Концентрација CO2 већа од {value}{unit}",
  "alerts.co2LessThan": "Концентрација CO2 мања од",
  "alerts.co2LessThanThreshold": "Концентрација CO2 мања од {value}{unit}",
  "alerts.conditions": "Услови",
  "alerts.createAlert": "Направи обавештење",
  "alerts.dailyPrecipitationGreaterThan": "Дневне падавине веће од",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Дневне падавине изнад прага од {value}{unit}",
  "alerts.deleteAlert": "Обриши обавештење",
  "alerts.editAlert": "Уреди обавештење",
  "alerts.editCondition": "Уреди услове",
  "alerts.gustSpeedGreaterThan": "Удари ветра јачи од",
  "alerts.gustSpeedGreaterThanThreshold": "Удари ветра су јачи од {value}{unit}",
  "alerts.gustSpeedLessThan": "Удари ветра су мањи од",
  "alerts.gustSpeedLessThanThreshold": "Удари ветра су мањи од {value}{unit}",
  "alerts.heatIndexGreaterThan": "Индекс топлоте већи од",
  "alerts.heatIndexGreaterThanThreshold": "Индекс топлоте већи од {value}{unit}",
  "alerts.heatIndexLessThan": "Индекс топлоте мањи од",
  "alerts.heatIndexLessThanThreshold": "Индекс топлоте мањи од {value}{unit}",
  "alerts.humidexGreaterThan": "Humidex већи од",
  "alerts.humidexGreaterThanThreshold": "Humidex већи од {value}{unit}",
  "alerts.humidexLessThan": "Humidex мањи од",
  "alerts.humidexLessThanThreshold": "Humidex мањи од {value}{unit}",
  "alerts.humidityGreaterThan": "Влажност ваздуха је већа од",
  "alerts.humidityGreaterThanThreshold": "Влажност ваздуха је већа од {value}{unit}",
  "alerts.humidityLessThan": "Влажност ваздуха је мања од",
  "alerts.humidityLessThanThreshold": "Влажност ваздуха је мања од {value}{unit}",
  "alerts.inProgress": "У току",
  "alerts.myAlerts": "Моја обавештења",
  "alerts.noConfiguredAlert": "Нисте до сада направили нити једно обавештење, почните тако што ћете га направити",
  "alerts.noiseGreaterThan": "Бука је јача од",
  "alerts.noiseGreaterThanThreshold": "Бука је јача од {value}{unit}",
  "alerts.noiseLessThan": "Бука је тиша од",
  "alerts.noiseLessThanThreshold": "Бука је тиша од {value}{unit}",
  "alerts.noteOnConditions": "Имајте на уму да је ово обавештење активирано када се испуне сви услови испод",
  "alerts.pm10GreaterThan": "PM 10 веће од",
  "alerts.pm10GreaterThanThreshold": "PM 10 веће од {value}{unit}",
  "alerts.pm10LessThan": "PM 10 мање од",
  "alerts.pm10LessThanThreshold": "PM 10 мање од {value}{unit}",
  "alerts.pm1GreaterThan": "PM 1 веће од",
  "alerts.pm1GreaterThanThreshold": "PM 1 веће од {value}{unit}",
  "alerts.pm1LessThan": "PM 1 мање од",
  "alerts.pm1LessThanThreshold": "PM 1 мање од {value}{unit}",
  "alerts.pm2p5GreaterThan": "PM 2.5 веће од",
  "alerts.pm2p5GreaterThanThreshold": "PM 2.5 веће од {value}{unit}",
  "alerts.pm2p5LessThan": "PM 2.5 мање од",
  "alerts.pm2p5LessThanThreshold": "PM 2.5 мање од {value}{unit}",
  "alerts.postStormSummary": "Резиме након падавина",
  "alerts.postStormSynopsisHelper": "Добићете обавештење са резимеом након сваке кише.",
  "alerts.postStormSynopsisSoleCondition": "Резиме након олује не може се комбиновати са другим условима.",
  "alerts.precipitationGreaterThan": "Часовне падавине веће од",
  "alerts.precipitationGreaterThanThreshold": "Часовне падавине изнад прага од {value}{unit}",
  "alerts.pressureGreaterThan": "Ваздушни притисак изнад",
  "alerts.pressureGreaterThanThreshold": "Ваздушни притисак изнад {value}{unit}",
  "alerts.pressureLessThan": "Ваздушни притисак испод",
  "alerts.pressureLessThanThreshold": "Ваздушни притисак нижи од {value}{unit}",
  "alerts.rainRateGreaterThan": "Интензитет кише већи од",
  "alerts.rainRateGreaterThanThreshold": "Интензитет кише изнад прага од {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Осунчаност већа од",
  "alerts.solarRadiationGreaterThanThreshold": "Осунчаност већа од {value}{unit}",
  "alerts.solarRadiationLessThan": "Осунчаност мања од",
  "alerts.solarRadiationLessThanThreshold": "Осунчаност мања од {value}{unit}",
  "alerts.temperatureGreaterThan": "Температура виша од",
  "alerts.temperatureGreaterThanThreshold": "Температура виша од {value}{unit}",
  "alerts.temperatureLessThan": "Температура нижа од",
  "alerts.temperatureLessThanThreshold": "Температура нижа од {value}{unit}",
  "alerts.thswGreaterThan": "THSW већи од",
  "alerts.thswGreaterThanThreshold": "THSW већи од {value}{unit}",
  "alerts.thswLessThan": "THSW мањи од",
  "alerts.thswLessThanThreshold": "THSW мањи од {value}{unit}",
  "alerts.thwGreaterThan": "THW већи од",
  "alerts.thwGreaterThanThreshold": "THW већи од {value}{unit}",
  "alerts.thwLessThan": "THW мањи од",
  "alerts.thwLessThanThreshold": "THW мањи од {value}{unit}",
  "alerts.uvGreaterThan": "UV индекс већи од",
  "alerts.uvGreaterThanThreshold": "UV индекс већи од {value}{unit}",
  "alerts.uvLessThan": "UV индекс мањи од",
  "alerts.uvLessThanThreshold": "UV индекс мањи {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "Видљивост већа од {value}{unit}",
  "alerts.visibilityLessThanThreshold": "Видљивост мања од {value}{unit}",
  "alerts.visiblityGreaterThan": "Видљивост већа од",
  "alerts.visiblityLessThan": "Видљивост мања од",
  "alerts.whichMeasure": "За која мерења желите да примате обавештења?",
  "alerts.whichModule": "За који модул бисте желели да будете упозорени?",
  "alerts.windChillGreaterThan": "Винд Цхилл већи од",
  "alerts.windChillGreaterThanThreshold": "Винд Цхилл већи од {value}{unit}",
  "alerts.windChillLessThan": "Винд Цхилл мањи од",
  "alerts.windChillLessThanThreshold": "Винд Цхилл мањи од {value}{unit}",
  "alerts.windSpeedGreaterThan": "Брзина ветра већа од",
  "alerts.windSpeedGreaterThanThreshold": "Брзина ветра већа од {value}{unit}",
  "alerts.windSpeedLessThan": "Брзина ветра мања од",
  "alerts.windSpeedLessThanThreshold": "Брзина ветра мања од {value}{unit}",
  "astral.astronomicalSunPhase": "Астрономски {sunPhase}",
  "astral.civilSunPhase": "Civil {sunPhase}",
  "astral.dawn": "Свитање",
  "astral.dusk": "Сумрак",
  "astral.firstQuarter": "Прва четврт",
  "astral.fullMoon": "Пун месец",
  "astral.lastQuarter": "Последња четврт",
  "astral.moon": "Месец",
  "astral.moonPhases": "Месечеве фазе",
  "astral.moonrise": "Излазак месеца",
  "astral.moonset": "Залазак месеца",
  "astral.nauticalSunPhase": "Наутички {sunPhase}",
  "astral.newMoon": "Млад месец",
  "astral.noon": "Подне",
  "astral.remainingDaylight": "Преостала обданица",
  "astral.sunrise": "Излазак сунца",
  "astral.sunriseAndSunset": "Излазак и залазак сунца",
  "astral.sunriseAt": "Излазак сунца у {time}",
  "astral.sunset": "Залазак сунца",
  "astral.sunsetAt": "Залазак сунца у {time}",
  "astral.totalDaylight": "Укупна обданица",
  "astral.waningCrescent": "трећа четврт",
  "astral.waningGibbous": "Опадајући месец",
  "astral.waxingCrescent": "прва четврт",
  "astral.waxingGibbous": "Растући Месец",
  "auth.alreadyHaveAccount": "Већ имате налог?",
  "auth.authContainerTagline": "Ваша лична временска табла. Повежите своје станице и добијте податке у реалном времену надохват руке.",
  "auth.backToLogin": "Назад на пријаву",
  "auth.catchPhrase": "Паметна платформа за праћење временских услова",
  "auth.checkYourEmail": "Проверите своју е-пошту",
  "auth.continueWithApple": "Наставите са Apple",
  "auth.continueWithFacebook": "Наставите са Facebook",
  "auth.continueWithGoogle": "Наставите са Google",
  "auth.email": "Адреса е-поште",
  "auth.emailRequiredLoginFacebook": "Потребна је потврда путем е-поште",
  "auth.emailVerification": "Е-маил Верификација",
  "auth.emailVerificationFailure": "Десио се проблем са верификацијом путем е-поште.",
  "auth.emailVerificationSuccess": "Ваша адреса е-поште је успешно верификована.",
  "auth.firstName": "Име",
  "auth.forgotPassword": "Заборавили сте лозинку?",
  "auth.forgotPasswordSubtitle": "Унесите своју е-пошту и послаћемо вам линк за ресетовање лозинке.",
  "auth.lastName": "Презиме",
  "auth.login": "Пријава",
  "auth.loginSubtitle": "Добродошли назад! Молимо унесите своје податке.",
  "auth.loginToSmartMixinDescription": "Унесите своје СмартМикин акредитиве да бисте приступили свом налогу.",
  "auth.logout": "Одјава",
  "auth.logoutConfirmation": "Да ли сте сигурни да желите да прекинете везу?",
  "auth.noAccountYet": "Још немате налог?",
  "auth.or": "или",
  "auth.password": "Лозинка",
  "auth.passwordAgain": "Поновите лозинку",
  "auth.passwordReset": "Ресет лозинке",
  "auth.passwordResetSuccess": "Ваша лозинка је успешно промењена.",
  "auth.register": "Креирај налог",
  "auth.registerDescription": "Направите бесплатан SmartMixin налог за повезивање ваших метеоролошких станица, праћење временских података и приступ напредним аналитичким алатима.",
  "auth.registerSubtitle": "Креирајте свој налог да бисте започели.",
  "auth.registerSuccess": "Успешно сте се регистровали! Управо смо вам послали верификациони мејл на {emailAddress} са детаљнијим инструкцијама.",
  "auth.restorePassword": "Поврати лозинку",
  "auth.restorePasswordSuccess": "Управо смо вам послали линк за ресет лозинке на {emailAddress} са детаљнијим инструкцијама.",
  "auth.sendReset": "Пошаљи инструкције за ресет",
  "auth.socialAccount": "или користите ваш налог",
  "auth.welcome": "Добродошли у SmartMixin",
  "auth.welcomeBack": "Добродошли назад!",
  "calendar.april": "Април",
  "calendar.august": "Август",
  "calendar.dateFormat": "Формат датума",
  "calendar.day": "Дан",
  "calendar.december": "Децембар",
  "calendar.end": "Крај",
  "calendar.february": "Фебруар",
  "calendar.hours": "Часови",
  "calendar.hoursShort": "часова",
  "calendar.january": "Јануар",
  "calendar.july": "Јул",
  "calendar.june": "Јун",
  "calendar.last24Hours": "последња 24 сата",
  "calendar.last30Days": "последњих 30 дана",
  "calendar.last7Days": "последњих 7 дана",
  "calendar.march": "Март",
  "calendar.max": "Максимум",
  "calendar.may": "Мај",
  "calendar.month": "Месец",
  "calendar.months": "месеци",
  "calendar.november": "Новембар",
  "calendar.october": "Октобар",
  "calendar.oneDay": "1-дан",
  "calendar.oneHour": "1-сат",
  "calendar.oneMonth": "1-месец",
  "calendar.oneWeek": "1-недеља",
  "calendar.previous24Hours": "Претходна 24 сата",
  "calendar.previous30Days": "Претходних 30 дана",
  "calendar.previous7Days": "Претходних 7 дана",
  "calendar.previousDay": "Претходни дан",
  "calendar.previousMonth": "Претходни месец",
  "calendar.previousWeek": "Претходну недељу",
  "calendar.previousYear": "Претходну годину",
  "calendar.sameDayLastYear": "На исти дан претходне године",
  "calendar.sameMonthLastYear": "Током истог месеца претходне године",
  "calendar.selectADate": "Изаберите датум",
  "calendar.selectAMonth": "Изаберите месец дана",
  "calendar.selectAYear": "Изаберите годишњу",
  "calendar.selectGranularity": "Изабери прецизност",
  "calendar.selectTimescale": "Изабери временску скалу",
  "calendar.september": "Септембар",
  "calendar.sixHours": "6-сати",
  "calendar.start": "Почетак",
  "calendar.thirtyMinutes": "30-минута",
  "calendar.threeHours": "3-сата",
  "calendar.use24HourFormat": "Користи 24-часовни формат",
  "calendar.week": "Недеља",
  "calendar.year": "Година",
  "calendar.yesterday": "Јучер",
  "common.accountDeleted": "Ваш налог је успешно избрисан.",
  "common.accountOnHold": "Веза вашег налога је истекла. Поново се повежите да бисте наставили ажурирање података.",
  "common.add": "Додај",
  "common.addAStation": "Додај станицу",
  "common.addToFavorites": "Додај у фаворите",
  "common.addYourOwnStation": "Додајте своје одмаралиште",
  "common.alreadyPremium": "Већ имате премијум налог!",
  "common.alsoAvailableOn": "Доступно и на:",
  "common.altitude": "Надморска висина",
  "common.analysis": "Анализа",
  "common.aroundMe": "У мојој близини",
  "common.articleCount": "{count, plural, one {count} чланак} few {count} чланка} other {count} чланака}}",
  "common.articleNotFound": "Чланак није пронађен",
  "common.articleNotFoundDescription": "Чланак који тражите не постоји.",
  "common.average": "Просек",
  "common.averageOverThePeriod": "Просек током периода",
  "common.away": "Одсутност",
  "common.back": "Назад",
  "common.backToHelpCenter": "Назад у центар за помоћ",
  "common.backToHome": "Назад на Почетну",
  "common.bad": "Лоше",
  "common.batteryLevel": "Ниво батерије",
  "common.bestValue": "Најбоља Вредност",
  "common.billingDetailsAndroid": "Бесплатна пробна верзија вам неће бити наплаћена уколико одустанете 24 часа пре истека пробног периода. Када пробни период заврши, можете да откажете претплату на SmartMixin у било ком тренутку преко Google Play-а, а у супротном ће претплата аутоматски да се обнавља. Ово морате да урадите бар 24 часа пре истека периода претплате како бисте избегли наплату за још један период у износу назначеном у дугмету изнад. Плаћање претплате ће бити обављено кроз Google Play када потврдите куповину и након испуњења услова за обнављање претплате за сваки следећи период.",
  "common.billingDetailsIos": "Бесплатна пробна верзија вам неће бити наплаћена уколико одустанете 24 часа пре истека пробног периода. Када пробни период заврши, можете да откажете претплату на SmartMixin у било ком тренутку преко ваше продавнице апликација, а у супротном ће претплата аутоматски да се обнавља. Ово морате да урадите бар 24 часа пре истека периода претплате како бисте избегли наплату за још један период у износу назначеном у дугмету изнад. Плаћање претплате ће бити обављено кроз вашу продавницу апликација када потврдите куповину и након испуњења услова за обнављање претплате за сваки следећи период.",
  "common.boilerOn": "Бојлер УКЉУЧЕН",
  "common.browseByCategory": "Прегледај по категорији",
  "common.calendarView": "Календарски преглед",
  "common.cancel": "Откажи",
  "common.cannotBeEmpty": "Ово поље не може бити празно.",
  "common.cardDetails": "Детаљи картице",
  "common.categoryNotFound": "Категорија није пронађена",
  "common.categoryNotFoundDescription": "Ова категорија не постоји или нема чланака.",
  "common.charts": "Дијаграми",
  "common.chartView": "Преглед дијаграма",
  "common.clearRecentLocations": "Очистити све",
  "common.close": "Затвори",
  "common.comparison": "Поређења",
  "common.currentDay": "Данас",
  "common.currentLocation": "Тренутна локација",
  "common.currentObservations": "Тренутне вредности",
  "common.currentRainEvent": "Тренутни догађај кише",
  "common.currentRate": "Интензитет кише",
  "common.currentWeatherConditions": "Тренутни услови",
  "common.customizeComparisonMetrics": "Прилагодите метрике",
  "common.customizeComparisonMetricsDescription": "Превлачите ставке да бисте поново организовали метрике поређења. Додирните икону ока да бисте приказали или скрили метрике.",
  "common.customizeDashboard": "Prilagodi",
  "common.customizeDashboardDescription": "Prevucite stavke da promenite redosled na kontrolnoj tabli. Dodirnite ikonu oka da prikažete ili sakrijete sekcije.",
  "common.customizedStationName": "Прилагођено име станице",
  "common.dailyForecast": "Дневна прогноза",
  "common.dashboard": "Преглед",
  "common.default": "Подразумевано",
  "common.defaultForecastModelChip": "Подразумевано · {name}",
  "common.delete": "Обриши",
  "common.deleteAccount": "Обрисати налог",
  "common.deleteAccountConfirmation": "Да ли сте сигурни да желите да избришете свој налог? Ова акција је неповратна.",
  "common.deleteAccountDescription": "Ова радња брише ваш налог и све ваше информације. Нема повратка.",
  "common.details": "Детаљи",
  "common.edit": "Уреди",
  "common.editor": "Уређивач",
  "common.endTime": "КРАЈ",
  "common.exitFullscreen": "Изађи из целог екрана",
  "common.exploreWeatherMap": "Истражите Временску Карту",
  "common.favoriteLocations": "Фаворити",
  "common.favoriteLocationsEmpty": "Можете да додате до 5 омиљених локација.",
  "common.favoriteStations": "Омиљене станице",
  "common.feedbackHelpsImprove": "Ваше повратне информације помажу нам да побољшамо чланке помоћи.",
  "common.filterStationDescription": "Не приказуј станице са непоузданим мерењима.",
  "common.filterStations": "Филтрирај станице",
  "common.filterStationSourceDescription": "Изаберите добављаче станица које желите да прикажете на мапи",
  "common.findStationsNearYou": "Пронађите станице у близини",
  "common.firmwareVersion": "Верзија фирмвера",
  "common.forecast": "Прогноза",
  "common.forecastComparisonDescription": "Лако упоредите податке из различитих доступних временских модела",
  "common.forecastModelComparison": "Поређење временских модела",
  "common.forecastModelCoverage": "Покривеност",
  "common.forecastModelDescription": "Опис",
  "common.forecastModelDescription_AROME": "Високорезолуциони модел Météo Francea који омогућава разлучивање конвекције над западном Европом са резолуцијом од 1,3 км. Најбољи у класи за краткорочне прогнозе у Француској; ажурира се сваких три сата.",
  "common.forecastModelDescription_ARPEGE_EU": "Европско гнездо модела ARPEGE Météo Francea са резолуцијом од 10 км. Средњорочне прогнозе над Европом, ажурирају се четири пута дневно.",
  "common.forecastModelDescription_ARPEGE_GLOBAL": "Глобални нумерички модел времена Météo Francea са резолуцијом од 25 км, до отприлике 4 дана. Ажурира се четири пута дневно.",
  "common.forecastModelDescription_EC_GDPS": "Глобални детерминистички систем предвиђања Environment Canada: светски средњорочни модел са резолуцијом од 15 км који иде до 10 дана, ажурира се два пута дневно.",
  "common.forecastModelDescription_EC_RDPS": "Регионални детерминистички систем предвиђања Environment Canada: средњорочни модел над Северном Америком са резолуцијом од 10 км, ажурира се четири пута дневно.",
  "common.forecastModelDescription_GFS": "Водећи средњорочни глобални модел NOAA. Покрива целу планету са резолуцијом од 25 км до 16 дана, ажурира се четири пута дневно.",
  "common.forecastModelDescription_HRRR_CONUS": "High-Resolution Rapid Refresh од NOAA: модел који омогућава разлучивање конвекције над континенталним САД са резолуцијом од 3 км, ажурира се сваких сат. Најпогоднији за веома краткорочне прогнозе грмљавинских олуја и јаког времена.",
  "common.forecastModelDescription_ICON_DE": "Високорезолуциони модел DWD-а који омогућава разлучивање конвекције над Немачком и суседним земљама са резолуцијом од 2,2 км. Краткорочне прогнозе ажурирају се два пута дневно.",
  "common.forecastModelDescription_ICON_EU": "Европско гнездо модела ICON DWD-а са резолуцијом од 7 км које покрива Европу и Северни Атлантик. Средњорочне прогнозе ажурирају се четири пута дневно.",
  "common.forecastModelDescription_MET_NORWAY": "Отворена услуга прогнозе времена Норвешког метеоролошког института, која комбинује високорезолуционе нордијске моделе са подацима ECMWF да би пружила глобалне прогнозе до 10 дана унапред.",
  "common.forecastModelDescription_MF_AROME_ANTILLES": "AROME гнездо над француским Антилима (Гваделупа, Мартиник) са резолуцијом од 2,5 км. Краткорочне прогнозе ажурирају се четири пута дневно.",
  "common.forecastModelDescription_MF_AROME_GUYANE": "AROME гнездо над Француском Гвајаном са резолуцијом од 2,5 км. Краткорочне прогнозе ажурирају се четири пута дневно.",
  "common.forecastModelDescription_MF_AROME_NOUVELLE_CALEDONIE": "AROME гнездо над Новом Каледонијом са резолуцијом од 2,5 км. Краткорочне прогнозе ажурирају се четири пута дневно.",
  "common.forecastModelDescription_MF_AROME_POLYNESIE": "AROME гнездо над Француском Полинезијом са резолуцијом од 2,5 км. Краткорочне прогнозе ажурирају се четири пута дневно.",
  "common.forecastModelDescription_MF_AROME_REUNION_MAYOTTE": "AROME гнездо над Реинионом и Мајотом са резолуцијом од 2,5 км. Краткорочне прогнозе ажурирају се четири пута дневно.",
  "common.forecastModelDescription_NAM_CONUS": "Гнездо North American Mesoscale модела NOAA над континенталним САД са резолуцијом од 5 км. Краткорочне прогнозе ажурирају се четири пута дневно.",
  "common.forecastModelDescription_NAM_NORTH_AMERICA": "North American Mesoscale модел NOAA који покрива целу Северну Америку са резолуцијом од 32 км. Ажурира се четири пута дневно.",
  "common.forecastModelDescription_SMARTMIXIN_MULTIMODEL": "Водећа прогноза SmartMixin-а. За сваки сат на вашој локацији бирамо најбољи доступни модел — обично високорезолуциони регионални модел тамо где постоји (AROME у Француској, ICON-D2 у Немачкој, HRRR у САД, ARPEGE Europe широм континента…) и враћамо се на глобални модел другде — затим попуњавамо све празнине из суседних извора. Резултат је јединствена беспрекорна прогноза која покрива било где у свету до 14 дана, аутоматски се ажурира сваки пут када се неки од основних модела ажурира.",
  "common.forecastModelDescription_WEATHERFLOW_FORECAST": "Власничка глобална прогноза Weatherflow која меша више нумеричких модела времена са посматрањима из своје мреже Tempest метеоролошких станица. Глобални хоризонт од 10 дана.",
  "common.forecastModelDetailTitle": "Прогностички модел",
  "common.forecastModelScopeGlobal": "Глобални",
  "common.forecastModelScopeGlobalDescription": "Овај модел покрива целу планету.",
  "common.forecastModelScopeRegional": "Регионални",
  "common.forecastModelScopeRegionalDescription": "Овај модел покрива само одређени регион.",
  "common.forecastModelSpecifications": "Спецификације",
  "common.forecastSources": "Извори прогнозе",
  "common.freeAccount": "Бесплатни налог",
  "common.freeSubscription": "Бесплатна претплата",
  "common.freeTrialForPeriod": "Бесплатни налог у трајању од {period} дана",
  "common.frequency": "Фреквенција",
  "common.full": "Пун",
  "common.fullscreen": "Цео екран",
  "common.getStartedFree": "Почните Бесплатно",
  "common.getUnlimitedAccess": "Неограничен приступ:",
  "common.good": "Добро",
  "common.help": "Помоћ",
  "common.helpCategoryAccount": "Налог",
  "common.helpCategoryBilling": "Наплата",
  "common.helpCategoryGettingStarted": "Први кораци",
  "common.helpCategoryProviders": "Провајдери",
  "common.helpCategoryStations": "Станице",
  "common.helpCategoryTroubleshooting": "Решавање проблема",
  "common.helpCenter": "Центар за помоћ",
  "common.helpCenterDescription": "Пронађите одговоре на честа питања и сазнајте како да максимално искористите SmartMixin.",
  "common.hg": "Заштита од мраза",
  "common.hidden": "Скривено",
  "common.hiddenSensors": "Скривени сензори",
  "common.hiddenStations": "Скривене станице",
  "common.hiddenStationsDescription": "Можете да сростите станицу тако што ћете тако додирнути икону за очи.",
  "common.high": "Високо",
  "common.home": "Кућа",
  "common.homeConnectService": "Поседујете метеоролошку станицу? Повежите свој сервис",
  "common.homeInformation": "Кућне информације",
  "common.homeIntroduction": "Повежите ваше вањске налоге како бисте уживали у могућностима програма SmartMixin.",
  "common.homeName": "Име куће",
  "common.homeSubtitle": "Ваше време, све на једном месту",
  "common.horizon": "Хоризонт",
  "common.horizonValue": "до {value} сати",
  "common.iDontKnowYet": "Још увек не знам",
  "common.indoor": "Унутра",
  "common.lastRainEvent": "Последња киша",
  "common.lastUpdate": "Последња провера",
  "common.legendLightningHelp": "Боја приказује старост сваке муње у последњих {minutes} минута — најновије белом, најстарије тамноцрвеном.",
  "common.legendNewest": "Најновије",
  "common.legendOldest": "Најстарије",
  "common.legendStationsHelp": "Боја ознаке одражава вредност изабране величине.",
  "common.lightningDataAttribution": "Подаци о муњама: Blitzortung.org",
  "common.lightningStrikes": "Удари муња",
  "common.lightningStrikesDescription": "Прикажи ударе муња у реалном времену на карти",
  "common.loading": "Учитавам",
  "common.location": "Локација",
  "common.locationAddedToFavorites": "Локација је додата у фаворите",
  "common.locationNotGranted": "Дозвола за локацију није одобрена. Молимо вас да дозволите приступ вашој локацији у подешавањима уређаја.",
  "common.locationRemovedFromFavorites": "Локација уклоњена из фаворита",
  "common.locations": "Локације",
  "common.low": "Ниско",
  "common.manage": "Управљај",
  "common.manageAccount": "Управљај налогом",
  "common.manageMySubscription": "Управљај претплатом",
  "common.manageSensors": "Управљање сензорима",
  "common.manageSensorsDescription": "Превуците ставке да бисте променили редослед сензора. Додирните икону ока да бисте приказали или сакрили сензоре. Додирните назив да бисте га преименовали.",
  "common.manualBoost": "Ручно повећање",
  "common.manualSetpointUntil": "Постави ручно тачку до",
  "common.mapLayers": "Слојеви карте",
  "common.mapLegend": "Легенда мапе",
  "common.maxFavoriteLocationsReached": "Можете да имате само до 5 најдражих локација. Уклоните један да бисте додали још један.",
  "common.measureToDisplay": "Мера за приказ",
  "common.medium": "Средње",
  "common.meshSize": "Величина мреже",
  "common.minRead": "{minutes} мин читања",
  "common.modifyFavoriteStations": "Измените омиљене станице",
  "common.modifyFavoriteStationsDescription": "Можете да преузмете своје омиљене станице повлачењем их. Такође их можете уклонити са листе.",
  "common.moduleType": "Тип модула",
  "common.monthTotal": "Овог месеца",
  "common.more": "Више",
  "common.moreInformation": "Више информација",
  "common.myLocation": "Моја локација",
  "common.nearbyWeatherStations": "Оближње метео-станице",
  "common.next": "Следећи",
  "common.nextHours": "Следећи сати",
  "common.no": "Не",
  "common.noAccountNeeded": "Није потребан налог",
  "common.noDataForThisPeriod": "Нема података у периоду",
  "common.noLocationsFound": "Нису пронађене локације",
  "common.noNetatmoWeatherStationYet": "Још увек немате Нетатмо Метеостаницу.",
  "common.noOutdoorModule": "Није откривен нити један вањски модул за ову станицу.",
  "common.noStationsFound": "Нису пронађене станице",
  "common.noThermostatYet": "Немате термостат.",
  "common.notNow": "Не сада",
  "common.notPurchasedYet": "Изгледа да овај производ још увек нисте купили.",
  "common.noWeatherStation": "Немате метеостаницу",
  "common.noWeatherStationYet": "Још увек немате метеостаницу.",
  "common.numberOfActiveWarnings": "{warning_count} активних упозорења о времену",
  "common.openSettings": "Отвори подешавања",
  "common.orChooseMonthly": "Или одабери месечно:",
  "common.outdatedModule": "Подаци са овог модула нису ажурни.",
  "common.outdoor": "Вани",
  "common.outdoorTemperature": "Вањска температура",
  "common.pageNotFound": "Страница Није Пронађена",
  "common.pageNotFoundDescription": "Страница коју тражите не постоји или је премештена.",
  "common.passwordUpdated": "Лозинка је успешно промењена.",
  "common.personalWeatherIntelligence": "Ваша Лична Временска Интелигенција",
  "common.premiumAccount": "Премијум налог",
  "common.premiumDescription": "Премијум налог откључава велики број додатних могућности попут напредне анализе времена, упоредних дијаграма, локалних прогностичких модела и још много тога.",
  "common.premiumFeatureAlerts": "Временска Упозорења",
  "common.premiumFeatureAnalysis": "Напредна Анализа Времена",
  "common.premiumFeatureCharts": "Упоређивање Графикона",
  "common.premiumFeatureExport": "Извоз Података",
  "common.premiumFeatureForecast": "Регионални Прогностички Модели",
  "common.premiumFeatureNotification": "Виџет Статусне Траке",
  "common.premiumFeatureTitle": "Премијум Функција",
  "common.premiumFeatureWidgets": "Виџети почетног екрана",
  "common.pressureSummary": "Синтеза притиска",
  "common.previous": "Превиоус",
  "common.previousHours": "Претходни сати",
  "common.profileUpdated": "Профил је успешно ажуриран.",
  "common.purchasedNetatmoPro": "Претходно сте купили Нетатмо Про ({date}). Претплатите се на једну од доле наведених понуда да бисте имали приступ свим премиум функцијама апликације.",
  "common.radarDataAttribution": "Подаци радара: RainViewer.com",
  "common.rain": "Киша",
  "common.rainEvents": "Кишни догађаји",
  "common.rainfallMeasurement": "Мерење количине падавина",
  "common.rainRadar": "Радар падавина",
  "common.rainRadarDescription": "Прикажите преклапање радара за кишу на мапи",
  "common.rainSummary": "Резиме падавина",
  "common.range": "Интервал",
  "common.recentLocations": "Недавни",
  "common.recentLocationsEmpty": "Недавна историја је празна.",
  "common.recentStations": "Недавне станице",
  "common.relatedArticles": "Повезани чланци",
  "common.relay": "Релеј",
  "common.removeFromFavorites": "Уклони из омиљених",
  "common.renameSensors": "Преименовање сензора",
  "common.resetZoom": "Ресетуј увећање",
  "common.restorePurchase": "Обнови куповину",
  "common.room": "Просторија",
  "common.rooms": "Просторије",
  "common.savingsPercent": "Уштедите {percent}%",
  "common.searchArticles": "Претражи чланке...",
  "common.searchForALocation": "Претражите локацију...",
  "common.searchForLocation": "Потражи локацију",
  "common.searchForWeatherStation": "Потражи метеостаницу",
  "common.searchResults": "Резултати претраге",
  "common.searchResultsEmpty": "Нема резултата.",
  "common.searchStationsDescription": "Унесите град, адресу или назив места да бисте пронашли метеоролошке станице у близини.",
  "common.searchStationsHint": "Користите траку за претрагу изнад да бисте открили метеоролошке станице било где у свету.",
  "common.selectStationForComparison": "Изаберите станицу за поређење",
  "common.selectWeatherForecastProvider": "Изаберите добављача временске прогнозе",
  "common.serialNumber": "Серијски број",
  "common.share": "Подели",
  "common.shareOutdoorMeasures": "Поделите ваша вањска мерења",
  "common.shareOutdoorMeasuresDescription": "Учествујте у заједници корисника апликације SmartMixin тако што ћете поделити мерења са вашег вањског модула. Мерења са унутрашњег модула никада неће бити дељена.",
  "common.shareYourWeather": "Поделите ваше временске услове",
  "common.signalStrength": "Јачина сигнала",
  "common.skip": "Прескочити",
  "common.smartThermostat": "Паметни термостат",
  "common.smartValve": "Паметни вентил",
  "common.snow": "Снег",
  "common.start": "Почети",
  "common.startFreeTrial": "Започните Бесплатни Пробни Период",
  "common.startTime": "Почетак",
  "common.station": "станица",
  "common.stationAddedToFavorites": "Станица је додата у омиљене",
  "common.stationComparison": "Поређење станица",
  "common.stationComparisonDescription": "Омогућава вам да упоредите историјске временске податке са подацима друге станице.",
  "common.stationInformation": "Информације о станици",
  "common.stationName": "Назив станице",
  "common.stationObservationsDescription": "Прикажите најновија запажања са метеоролошких станица",
  "common.stationRemovedFromFavorites": "Станица је уклоњена из омиљених",
  "common.stations": "станице",
  "common.stationsNear": "Станице у близини",
  "common.stationType": "Тип станице",
  "common.statusOffline": "Ван мреже",
  "common.statusOnline": "На мрежи",
  "common.statusStale": "Застарело",
  "common.statusSyncing": "Синхронизација",
  "common.subscribeNow": "Претплати се сада - без пробног периода",
  "common.sumOverThePeriod": "Акумулирано током периода",
  "common.switchToPremium": "Пређи на SmartMixin Premium",
  "common.temperatureShort": "Темп.",
  "common.temperatureSummary": "Резиме температуре",
  "common.thankYouForFeedback": "Хвала на повратним информацијама!",
  "common.thenPrice": "затим {price}",
  "common.timeSelection": "Избор периода",
  "common.timezone": "Временска зона",
  "common.totalDuration": "Укупно трајање",
  "common.tryAnotherLocation": "Нисмо могли да пронађемо метеоролошке станице у близини ове локације. Покушајте да претражујете у другом подручју.",
  "common.unknown": "Непознат",
  "common.untilChanged": "Док се не промени",
  "common.untilTime": "до {time}",
  "common.upgrade": "Надогради",
  "common.upgradeRequiredAndroid": "Потребна је надоградња апликације. Посетите Google Play ради надоградње.",
  "common.upgradeRequiredIos": "Потребна је надоградња апликације. Идите у ваши продавницу апликација ради надоградње.",
  "common.validate": "Потврди",
  "common.validEmail": "Потребна је важећа адреса е-поште.",
  "common.very_low": "Веома ниско",
  "common.visitNetatmoWebsite": "Посетите сајт Нетатмо",
  "common.wasArticleHelpful": "Да ли вам је овај чланак био користан?",
  "common.weatherCondition": "Услови времена",
  "common.weatherflowNCRain": "НЦ киша (скора киша)",
  "common.weatherflowNCRainDescription": "НЦ Раин је додатни извор података који се обезбеђује преко Темпест Веатхер Систем-а, који покреће технологија Неарцаст. Подаци о НЦ Раин су процена просечне акумулације падавина око вашег Темпест-а на нивоу суседства",
  "common.weatherForecastModels": "Модели временске прогнозе",
  "common.weatherIntelligencePlatform": "Платформа Временске Интелигенције",
  "common.weatherMap": "Метеокарта",
  "common.weatherMapMetaDescription": "SmartMixin нуди интерактивне мапе времена и радара за временске услове широм света.",
  "common.weatherObservations": "Временска запажања",
  "common.weatherStation": "Метеостаница",
  "common.weatherStations": "Метеостанице",
  "common.welcome": "Добродошли у SmartMixin!",
  "common.whenBackHome": "Када се враћате кући?",
  "common.wifiStrength": "Јачина сигнала WiFi",
  "common.wind": "Ветар",
  "common.windMeasurement": "Мерења ветра",
  "common.windSpeed": "Брзина ветра",
  "common.windSummary": "Синтеза ветра",
  "common.yearToDate": "Ове године",
  "common.yes": "да",
  "intro.locationDescription": "Omogućite pristup lokaciji za precizne vremenske prognoze prilagođene vašem tačnom području — bez univerzalnih prognoza.",
  "intro.locationTitle": "Prognoze napravljene za vas",
  "intro.notificationDescription": "Uključite obaveštenja za pravovremena upozorenja o vremenskim promenama koje su vam važne — kiša, sneg ili teški uslovi, baš kada treba.",
  "intro.notificationsTitle": "Nikada ne propustite promenu vremena",
  "intro.readyDescription": "Uživajte u preciznim prognozama, vremenskim uvidima u realnom vremenu i podacima sa stanica širom sveta — sve u jednoj moćnoj aplikaciji.",
  "intro.readyTitle": "Spremni ste!",
  "intro.welcomeDescription": "Dobijte hiperlokalne prognoze od najboljih meteoroloških agencija — plus pristup preko 40.000 meteoroloških stanica širom sveta za realne uslove, prošle i sadašnje.",
  "intro.welcomeTitle": "Vaša vremenska prognoza, osmišljena iznova",
  "landing.alerts": "Алертс",
  "landing.alertsDescription": "Креирајте сопствена упозорења и добијајте обавештења чим се активирају.",
  "landing.featureAlertsDescription": "Поставите прилагођена упозорења за услове који вас занимају—температура, ветар, падавине и више.",
  "landing.featureAlertsTitle": "Паметна упозорења",
  "landing.featureAnalyticsDescription": "Уроните у своје податке са интерактивним графиконима, упоређивањима један поред другог и анализом трендова изван основних метрика.",
  "landing.featureAnalyticsTitle": "Моћна аналитика",
  "landing.featureExportDescription": "Преузмите своје податке у CSV формату за анализу у Excel-у, интеграцију са другим системима или резервну копију.",
  "landing.featureExportTitle": "Извоз било где",
  "landing.featureForecastDescription": "Упоредите прогнозе из више од 10 метеоролошких модела укључујући GFS, ECMWF, ICON и друге да видите који најбоље функционише за вашу локацију.",
  "landing.featureForecastTitle": "Упоређивање прогноза",
  "landing.featureHistoryDescription": "Приступ историјским подацима са сатном, дневном и месечном скалом. Извоз у CSV за истраживање или личне архиве.",
  "landing.featureHistoryTitle": "Богата историја",
  "landing.featureMultiBrandDescription": "Повежите станице од Netatmo, Ecowitt, Ambient Weather, Davis, WeatherFlow и других—све на једној контролној табли.",
  "landing.featureMultiBrandTitle": "Подршка за више марки",
  "landing.featuresSubtitle": "Дизајнирано за љубитеље времена који захтевају више од основне апликације метеоролошке станице.",
  "landing.featuresTitle": "Све што вам треба за анализу времена",
  "landing.finalCtaButton": "Направите бесплатан налог",
  "landing.finalCtaSubtitle": "Придружите се хиљадама љубитеља времена који верују SmartMixin-у за своје временске податке.",
  "landing.finalCtaTitle": "Спремни да побољшате своје временско искуство?",
  "landing.forecastDescription": "Приступите неким од најбољих модела временске прогнозе и упоредите их да бисте стекли своју идеју какво ће бити време.",
  "landing.forecasts": "Прогнозе",
  "landing.heroCta": "Почните бесплатно",
  "landing.heroDescription": "Повежите више метеоролошких станица било које марке, упоредите моделе прогнозе и анализирајте своје податке са детаљним графиконима и извозом.",
  "landing.heroSecondaryCta": "Погледајте функције",
  "landing.heroTagline": "За љубитеље времена",
  "landing.heroTitle": "Сви временски подаци. Једна платформа.",
  "landing.pricingFeatureAdvancedMetrics": "Напредне метрике",
  "landing.pricingFeatureAlerts": "Прилагођена упозорења",
  "landing.pricingFeatureExport": "Извоз података (CSV)",
  "landing.pricingFeatureForecastComparison": "Поређење прогноза",
  "landing.pricingFeatureForecasts": "Модели прогнозе",
  "landing.pricingFeatureForecastsFreeTier": "1 модел",
  "landing.pricingFeatureForecastsPremiumTier": "Сви модели (10+)",
  "landing.pricingFeatureReports": "Анализе и извештаји",
  "landing.pricingFeatureStationComparison": "Поређење станица",
  "landing.pricingFeatureWidgets": "Виџети за почетни екран",
  "landing.pricingFeatureYearOverYear": "Анализа година за годином",
  "landing.pricingFree": "Бесплатно",
  "landing.pricingFreeCta": "Почните",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Најпопуларније",
  "landing.pricingPremium": "Премиум",
  "landing.pricingPremiumCta": "Започните",
  "landing.pricingPremiumDescription": "Од 1,99 €/месец — претплатите се на вебу, App Store-у или Google Play-у",
  "landing.pricingSubtitle": "Почните бесплатно, надоградите када вам треба више.",
  "landing.pricingTitle": "Једноставне, транспарентне цене",
  "landing.smartMixinDescription": "СмартМикин је апликација која омогућава приступ вашој метеоролошкој станици и 40К+ другим станицама широм света. Помаже вам да видите и разумете временске податке.",
  "landing.statBrands": "Подржане марке",
  "landing.statForecasts": "Модела прогнозе",
  "landing.statStations": "Повезаних станица",
  "landing.supportedDevices": "Подржани уређаји",
  "landing.supportedDevicesDescription": "Поред станица Светске метеоролошке организације, СмартМикин подржава све већи број брендова метеоролошких станица.",
  "landing.supportedDevicesNote": "Плус преко 40.000 јавних станица Светске метеоролошке организације",
  "landing.supportedDevicesSubtitle": "Повежите метеоролошке станице водећих марки и прегледајте све податке на једном месту.",
  "landing.supportedDevicesTitle": "Ради са вашим станицама",
  "landing.thermostatDescription": "Повежите свој Netatmo термостат да упоредите обрасце грејања са спољашњим условима.",
  "landing.thermostatManufacturers": "Произвођачи термостата такође имају подршку да повезују грејање са спољним условима.",
  "landing.thermostatTitle": "Интеграција са паметним домом",
  "landing.weatherAnalysis": "Анализа времена",
  "landing.weatherAnalysisDescription": "СмартМик долази са пуно визуелизације података која вам омогућава да анализирате временске податке.",
  "landing.weatherAssistant": "Ваш временски помоћник",
  "landing.weatherAssistantDescription": "Без обзира да ли сте заинтересовани за тренутне, историјске или прогнозиране временске прилике, СмартМикин пружа бројне увиде кад год вам затребају.",
  "landing.weatherForecastModels": "Модели временске прогнозе",
  "landing.weatherForecastModelsDescription": "СмартМикин омогућава приступ најпрецизнијим моделима временске прогнозе. Можете лако упоредити њихове прогнозе и направити своју идеју.",
  "landing.weatherMap": "Временска карта",
  "landing.weatherMapDescription": "Прегледајте мапу и визуализујте какво је време било где широм света.",
  "network.cancelError": "Захтев је отказан",
  "network.connectionError": "Сервер је недоступан",
  "network.networkError": "Мрежа није доступна",
  "network.serverError": "Нешто је погрешно...",
  "network.timeoutError": "Повезивање је истекло",
  "network.unknownError": "Непозната грешка",
  "providerHints.ambientWeatherApiKey": "Kreirano u podešavanjima naloga na ambientweather.net.",
  "providerHints.davisApiSecret": "Prikazuje se samo jednom prilikom kreiranja V2 API ključa — čuvajte ga bezbedno.",
  "providerHints.davisV2ApiKey": "Sa stranice V2 API ključeva na weatherlink.com.",
  "providerHints.ecowittApi": "Sa stranice API vašeg Ecowitt naloga.",
  "providerHints.ecowittApp": "Ključ aplikacije, takođe iz vašeg Ecowitt naloga.",
  "providerHints.myAcuriteCredentialsBanner": "Koristite e-mail i lozinku vašeg My AcuRite naloga — ne SmartMixin prijavu.",
  "providerHints.myAcuriteEmail": "E-mail vašeg My AcuRite naloga — ne vaša SmartMixin prijava.",
  "providerHints.myAcuritePassword": "Lozinka vašeg My AcuRite naloga.",
  "providerHints.weatherflowToken": "Token za ličnu upotrebu sa tempestwx.com → podešavanja → autorizacije podataka.",
  "providerHints.wundergroundEditKey": "Koristi drugi ključ",
  "providerHints.wundergroundKey": "Dugačak niz znakova sa stranice API ključeva vašeg Weather Underground naloga — ne vaša lozinka za wunderground.com.",
  "providerHints.wundergroundKeyExample": "npr. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API ključ proveren",
  "providerHints.wundergroundKeyVerifying": "Provera ključa…",
  "providerHints.wundergroundNoStationsNearby": "Nije pronađena nijedna stanica u blizini. Pokušajte da unesete ID stanice direktno.",
  "providerHints.wundergroundStationId": "Bilo koja oznaka stanice Weather Underground — vaša ili javna stanica u blizini.",
  "providerHints.wundergroundStationIdExample": "npr. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Nabavite svoj Ambient Weather API ključ.",
  "providerIntro.davisStep2": "Nabavite svoj Davis V2 API ključ i API tajnu.",
  "providerIntro.ecowittStep2": "Nabavite svoj Ecowitt API ključ i ključ aplikacije.",
  "providerIntro.getStarted": "Započni",
  "providerIntro.myAcuriteStep2": "Koristite e-mail i lozinku svog postojećeg My AcuRite naloga.",
  "providerIntro.netatmoEnergyStep2": "Prijavite se na Netatmo kada budete upitani — API ključ nije potreban.",
  "providerIntro.netatmoWeatherStep2": "Prijavite se na Netatmo kada budete upitani — API ključ nije potreban.",
  "providerIntro.signupBanner": "Skoro gotovo — kreirajte svoj besplatni SmartMixin nalog za povezivanje {provider}.",
  "providerIntro.step1": "Prijavite se na svoj SmartMixin nalog (NE na {provider}).",
  "providerIntro.step3EmailPassword": "Unesite ih ovde.",
  "providerIntro.step3KeyOrToken": "Nalepite ovde.",
  "providerIntro.step3OAuth": "Autorizujte SmartMixin u iskačućem prozoru.",
  "providerIntro.step3Wunderground": "Nalepite svoj API ključ, zatim izaberite obližnju stanicu ili unesite bilo koji ID stanice.",
  "providerIntro.title": "Poveži {provider}",
  "providerIntro.weatherflowStep2": "Nabavite svoj lični Tempest token.",
  "providerIntro.wundergroundBrowsePublic": "Nemate stanicu? Pregledajte javne",
  "providerIntro.wundergroundFindNearby": "Pronađi stanice u blizini",
  "providerIntro.wundergroundOrEnterId": "Ili unesite ID stanice",
  "providerIntro.wundergroundStep2": "Nabavite svoj Weather Underground API ključ. Zatim možete povezati bilo koju stanicu — svoju ili javnu.",
  "reports.agroMeteorology": "Агрометеорологија",
  "reports.analysis": "Анализа",
  "reports.annualCumulativeRainfallComparison": "Поређење укупних годишњих падавина",
  "reports.annualHeatingDurationComparison": "Годишње поређење времена грејања",
  "reports.annualHeatingEfficiency": "Годишња учинковитост грејања",
  "reports.annualIndoorComparison": "Годишње поређење унутрашњег модула",
  "reports.annualIndoorReport": "Годишњи извештај о унутрашњем модулу",
  "reports.annualOutdoorComparison": "Годишње поређење вањског модула",
  "reports.annualOutdoorReport": "Годишњи извештај о вањском модулу",
  "reports.annualReport": "Годишњи извештај",
  "reports.annualSolarReport": "Годишњи соларни извештај",
  "reports.annualWaterBalance": "Годишњи биланс воде",
  "reports.annualWaterBalanceCarryOver": "Пренеси из претходне године",
  "reports.annualWaterBalanceDescription": "Водени биланс (поједностављена верзија, користе се само киша и евапотранспирација) омогућава управљање водним ресурсима",
  "reports.avgHumidity": "Просечна влажност ваздуха",
  "reports.avgMaxTemperature": "Просечна T°max",
  "reports.avgMinTemperature": "Просечна T°min",
  "reports.avgPressure": "Просечна вредност ваздушног притиска",
  "reports.avgTemperature": "Просечна температура",
  "reports.comfortable": "Угодна (45% {lessThan} влажност ваздуха ≤ 60%)",
  "reports.cumulativeRainfall": "Кумулативне падавине",
  "reports.cumulativeRainfallDescription": "Пратите укупне падавине које се акумулирају током изабраног периода.",
  "reports.dailyMaxRainfall": "Максималне дневне падавине",
  "reports.dataExport": "Извези податке",
  "reports.dataExportXlsxFormatDescription": "Извезите све ваше податке у ексел фајл (*.xlsx). Након што кликнете на дугме, након пар минута ћете добити мејл са обрађеним подацима.",
  "reports.daysWithFrost": "Дани са мразом",
  "reports.daysWithoutThaw": "Ледени дани (T°max < 0°C)",
  "reports.daysWithStrongFrost": "Дани са јаким мразом",
  "reports.emailSent": "Мејл је послат на вашу адресу е-поште",
  "reports.grasslandTemperatureSum": "Температурна сума травњака",
  "reports.grasslandTemperatureSumDescription": "Ако је сума у пролеће већа од {threshold}, у Европи започиње одржив стар вегетације",
  "reports.growingDegreeDays": "Растући степен-дани",
  "reports.highPressure": "Антициклон (Просечна вредност притиска ≥ 1013mbar)",
  "reports.indoorReport": "Извештај унутрашњег модула",
  "reports.keyFacts": "Важне чињенице",
  "reports.longestRunOfRainyDays": "Број узастопних кишних дана",
  "reports.longestRunWithoutRun": "Број узастопних дана без кише",
  "reports.lowPressure": "Низак притисак (просечна вредност притиска {lessThan} 1013mbar)",
  "reports.maxHumidity": "Максимална влажност",
  "reports.maxPressure": "Највиши притисак",
  "reports.maxPressureMagnitude24h": "Максимална промена (/24H)",
  "reports.maxTemperature": "Највиша температура",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Максимална промена (/24H)",
  "reports.minHumidity": "Минимална влажност",
  "reports.minPressure": "Најнижи притисак",
  "reports.minPressureMagnitude24h": "Минимална промена (/24H)",
  "reports.minTemperature": "Најнижа температура",
  "reports.minTempMagnitude24h": "Минимална промена(/24H)",
  "reports.monthlyHeatingEfficiency": "Месечна учинковитост грејања",
  "reports.monthlyIndoorReport": "Месечни извештај унутрашњег модула",
  "reports.monthlyOutdoorReport": "Месечни извештај вањског модула",
  "reports.monthlyReport": "Месечни извештај",
  "reports.monthlySolarReport": "Месечни соларни извештај",
  "reports.monthlyWindReport": "Месечни извештај о ветру",
  "reports.numberOfDays": "Број дана",
  "reports.outdoorReport": "Извештај вањског модула",
  "reports.rainfall": "Падавине",
  "reports.rainyDays": "Дани са падавинама",
  "reports.relativelyWet": "Релативно влажно (60% {lessThan} Влажност ≤ 80%)",
  "reports.sendEmail": "Пошаљи мејл",
  "reports.tooDry": "Сувише суво (Влажност ≤ 45%)",
  "reports.tooWet": "Спарно (Влажност {greaterThan} 80%)",
  "reports.tropicalNights": "Тропске ноћи",
  "reports.waterBalance": "Биланс воде",
  "reports.yearToDateTemperature": "Температура од године до данас",
  "reports.yearToDateTemperatureComparison": "Поређење температуре од године до датума",
  "sensors.aqiByChannel": "AQI по каналу",
  "sensors.bgtSensors": "Црна кугла и WBGT",
  "sensors.cameraFeed": "Камера",
  "sensors.compareAqi": "Упореди AQI",
  "sensors.compareHumidity": "Упореди влажност",
  "sensors.compareMoisture": "Упореди влагу земље",
  "sensors.comparePm25": "Упореди PM2.5",
  "sensors.compareTemperatures": "Упореди температуре",
  "sensors.depthByChannel": "Dubina po kanalu",
  "sensors.heatStressExtreme": "Ekstreman toplotni stres",
  "sensors.heatStressModerate": "Umeren toplotni stres",
  "sensors.heatStressNone": "Nema toplotnog stresa",
  "sensors.heatStressStrong": "Jak toplotni stres",
  "sensors.heatStressVeryStrong": "Veoma jak toplotni stres",
  "sensors.humidityByChannel": "Влажност по каналу",
  "sensors.indoorAirQuality": "Квалитет ваздуха унутра",
  "sensors.indoorAirQualityPm": "PM2.5 и PM10 AQI",
  "sensors.indoorClimate": "Унутрашња клима",
  "sensors.indoorCo2Levels": "Нивои CO2",
  "sensors.indoorTemperatureAndHumidity": "Температура и влажност",
  "sensors.last24Hours": "24 сата",
  "sensors.last30Days": "30 дана",
  "sensors.last7Days": "7 дана",
  "sensors.leafTemperatureByChannel": "Температура листова по каналу",
  "sensors.leafWetnessByChannel": "Влажност листова по каналу",
  "sensors.lightningSensor": "Муња",
  "sensors.moistureByChannel": "Влага земље по каналу",
  "sensors.noDataAvailable": "Нема доступних података",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 по каналу",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Изаберите канал",
  "sensors.sensorDetailDescription": "Прегледајте историјске податке и трендове за канале сензора.",
  "sensors.sensorHistory": "Историја сензора",
  "sensors.soilConductivityByChannel": "Проводљивост по каналу",
  "sensors.soilTemperatureByChannel": "Температура земље по каналу",
  "sensors.strikesToday": "Удари данас",
  "sensors.temperatureByChannel": "Температура по каналу",
  "settings.about": "О програму",
  "settings.aboutDescription": "Споразум о лиценци, политика приватности",
  "settings.account": "Налог",
  "settings.accountDescription": "Профил, промена лозинке",
  "settings.accountIntro": "Подаци који се тичу вашег налога:",
  "settings.accountSection": "Налог",
  "settings.appearance": "Изглед",
  "settings.appearanceDescription": "Тема и опције приказа",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "Арапски",
  "settings.availableServices": "Доступно",
  "settings.bulgarian": "бугарски",
  "settings.cannotDisconnectLastAccount": "Није могуће одспојити једини метод пријаве. Прво додајте други метод пријаве.",
  "settings.changeEmail": "Промени е-пошту",
  "settings.changePassword": "Промени лозинку",
  "settings.chartGestures": "Гесте на дијаграму",
  "settings.chartGesturesDescription": "Преласком преко дијаграма мењате период, скупљањем прстима мењате временску скалу",
  "settings.connect": "Повежи",
  "settings.connected": "Повезано",
  "settings.connectedAccounts": "Повезани налози",
  "settings.connectedAccountsDescription": "Apple, Google, Facebook",
  "settings.connectedServices": "Повезано",
  "settings.connectedSince": "Повезано од {date}",
  "settings.connectionSuccess": "{provider} налог успешно повезан",
  "settings.contactUs": "Контактирајте нас",
  "settings.contactUsDescription": "Затражите помоћ или пошаљите повратну информацију",
  "settings.croatian": "Хрватски",
  "settings.currentPassword": "Тренутна лозинка",
  "settings.czech": "Чешки",
  "settings.danish": "Дански",
  "settings.dark": "Тамна тема",
  "settings.dataDisplay": "Приказ података",
  "settings.dateAndTime": "Датум и време",
  "settings.disconnect": "Одспоји",
  "settings.disconnectConfirmation": "Да ли сте сигурни да желите одспојити {provider} налог?",
  "settings.disconnectionSuccess": "{provider} налог успешно одспојен",
  "settings.donateButton": "Донирајте",
  "settings.donateDescription": "SmartMixin развија мали тим. Ако вам је користан, можете подржати његов развој једнократном донацијом у било ком износу. То је поклон — не мења ваш план нити откључава било какве функције.",
  "settings.donateSuccessBody": "Ваша донација помаже да SmartMixin настави да ради и да се унапређује. Искрено то ценимо.",
  "settings.donateSuccessTitle": "Хвала вам на подршци!",
  "settings.donateTitle": "Подржите SmartMixin",
  "settings.dutch": "Низоземски",
  "settings.emailChange": "Промени адресу е-поште",
  "settings.emailChangeConfirmation": "Потврда промене е-поште",
  "settings.emailChangeFailure": "Линк за промену е-поште је неважећи или је истекао.",
  "settings.emailChangeSuccess": "Ваша е-пошта је успешно промењена у {newEmail}.",
  "settings.emailChangeVerificationSent": "Верификациони е-маил је послат на вашу нову адресу е-поште. Проверите своје пријемно сандуче и кликните на линк да потврдите промену.",
  "settings.english": "Енглески",
  "settings.forecastModelOrderEmpty": "Нема сачуваног редоследа — подразумевано користимо GFS.",
  "settings.forecastModelOrderFreeHint": "Премиум модели захтевају SmartMixin Premium претплату.",
  "settings.forecastModelOrderHelp": "Бирамо први модел са ваше листе који покрива сваку станицу.",
  "settings.forecastModelOrderReset": "Ресетуј",
  "settings.forecastModelOrderTitle": "Подразумевани модел прогнозе",
  "settings.forecastModels": "Модели прогнозе",
  "settings.forecastModelsDescription": "Прерасподели по жељи",
  "settings.french": "Француски",
  "settings.german": "Немачки",
  "settings.gestures": "Гесте",
  "settings.greek": "Грчки",
  "settings.helpCenter": "Центар за помоћ",
  "settings.helpCenterDescription": "Често постављана питања и водичи",
  "settings.hungarian": "Мађарски",
  "settings.integrationsSection": "Интеграције",
  "settings.italian": "Италијански",
  "settings.japanese": "јапански",
  "settings.korean": "корејски",
  "settings.language": "Језик",
  "settings.languageDescription": "Језик по избору",
  "settings.light": "Светла тема",
  "settings.newEmailAddress": "Нова адреса е-поште",
  "settings.newPassword": "Нова лозинка",
  "settings.newPasswordAgain": "Поновите нову лозинку",
  "settings.norwegian": "Норвешки",
  "settings.notConnected": "Није повезано",
  "settings.notificationsSection": "Обавештења",
  "settings.oldPassword": "Стара лозинка",
  "settings.ongoingNotificationEnabled": "Омогући трајно обавештење",
  "settings.ongoingNotificationMetrics": "Приказане метрике",
  "settings.ongoingNotificationMetricsHint": "Превуците да бисте променили редослед изабраних мерења",
  "settings.ongoingNotificationPermissionRequired": "Потребна је дозвола за обавештења",
  "settings.ongoingNotificationStation": "Метеоролошка станица",
  "settings.passwordChange": "Промена лозинке",
  "settings.polish": "Пољски",
  "settings.portuguese": "португалски",
  "settings.preferencesSection": "Подешавања",
  "settings.premium": "Премијум",
  "settings.premiumActive": "Активно",
  "settings.premiumAnnualThenPrice": "Затим 9,99 €/годишње",
  "settings.premiumAnnualTrialInfo": "Започните са бесплатним пробним периодом од {days} дана",
  "settings.premiumCurrentPlan": "Current Plan",
  "settings.premiumDescription": "Откључај погодности премијум налога",
  "settings.premiumDownloadApp": "Download the app to subscribe:",
  "settings.premiumExpiresOn": "Renews on {date}",
  "settings.premiumFreePlan": "Free",
  "settings.premiumInactive": "Без претплате",
  "settings.premiumManageWebSubscription": "Управљајте претплатом, ажурирајте начин плаћања или откажите.",
  "settings.premiumPremiumPlan": "Premium",
  "settings.premiumSubscribeAnnual": "Годишње — 9,99 €/година",
  "settings.premiumSubscribedOn": "Subscribed on {platform}",
  "settings.premiumSubscribeMonthly": "Месечно — 1,99 €/месец",
  "settings.premiumSubscribeOnWeb": "Претплатите се сада да откључате све премиум функције.",
  "settings.premiumSubscriptionSuccess": "Ваша претплата је активирана! Уживајте у свим премиум функцијама.",
  "settings.premiumSubscriptionSuccessTitle": "Добродошли у Premium!",
  "settings.premiumWebappNotice": "Subscriptions can only be purchased through the SmartMixin mobile app on iOS or Android.",
  "settings.privacyPolicy": "Политика приватности",
  "settings.profile": "Профил",
  "settings.russian": "Руски",
  "settings.serbian": "Српски",
  "settings.settings": "Подешавања",
  "settings.slovak": "словачки",
  "settings.smallDecimals": "Мали децимали",
  "settings.smallDecimalsDescription": "Приказуј децималне цифре у мањој величини",
  "settings.socialConnectionsIntro": "Повежите своје друштвене налоге за брзу пријаву. Можете повезивати или одспајати налоге у било ком тренутку.",
  "settings.spanish": "Шпански",
  "settings.statusBarWidget": "Виџет статусне траке",
  "settings.statusBarWidgetDescription": "Увек видљиви временски подаци",
  "settings.subscriptionSection": "Претплата",
  "settings.supportSection": "Подршка",
  "settings.swedish": "Шведски",
  "settings.systemTheme": "Системска тема",
  "settings.termsOfService": "Услови коришћења",
  "settings.turkish": "Турски",
  "settings.ukrainian": "украјински",
  "settings.units": "Јединице",
  "settings.unitsDescription": "Мерне јединице приказане унутар апликације",
  "settings.update": "Ажурирај",
  "settings.updateYourProfile": "Ажурирајте ваш профил",
  "settings.weatherServices": "Метеоролошке услуге",
  "settings.weatherServicesConnected": "{count, plural, =0 {Нема повезаних услуга} one {# повезана услуга} few {# повезане услуге} other {# повезаних услуга}}",
  "settings.weatherServicesDescription": "Повежите Netatmo, Davis, Weatherflow и остало",
  "settings.windDirectionConvention": "Стрелица правца ветра",
  "settings.windDirectionConventionDescription": "Изаберите приказ стрелица правца ветра",
  "settings.windDirectionMeteorological": "Правац порекла",
  "settings.windDirectionMeteorologicalDescription": "Стрелица показује одакле ветар дува (meteorological конвенција)",
  "settings.windDirectionOceanographic": "Правац струјања",
  "settings.windDirectionOceanographicDescription": "Стрелица показује куда ветар дува (oceanographic конвенција)",
  "units.absolutePressure": "Апсолутни притисак",
  "units.airDensity": "Густина ваздуха",
  "units.airGap": "Vazdušni razmak",
  "units.apparentTemperature": "Привидна температура",
  "units.AQI": "AQI",
  "units.AQI_24H": "24h AQI",
  "units.avg": "Просек",
  "units.beaufort": "Beaufort",
  "units.blackGlobeTemperature": "Темп. црне кугле",
  "units.boilerOn": "Бојлер УКЉУЧЕН",
  "units.co2": "CO2",
  "units.conductivity": "Проводљивост",
  "units.coolingDegreeDays": "Дани расхлађивања",
  "units.dailyHeatingDuration": "Дневно трајање загревања",
  "units.dailyPrecipitation": "Дневне падавине",
  "units.dailyRain": "Дневна киша",
  "units.degreeDay": "Дневни степени",
  "units.degreeDayShort": "ДС",
  "units.depth": "Dubina",
  "units.depthSensors": "Senzori dubine",
  "units.dewPoint": "Тачка рошења",
  "units.distance": "Удаљеност",
  "units.downTrend": "Силазни тренд",
  "units.E": "И",
  "units.E_long": "Исток",
  "units.ENE": "ИСИ",
  "units.ENE_long": "исток-североисток",
  "units.ESE": "ИЈИ",
  "units.ESE_long": "исток-југоисток",
  "units.ET": "Евапотранспирација",
  "units.ETshort": "И",
  "units.feelLike": "Субјективни осећај",
  "units.feelsLike": "Субјективни осећај",
  "units.footMile": "Стопа, миља",
  "units.frostPoint": "тачка мраза",
  "units.gust": "Удари ветра",
  "units.heatIndex": "Индекс топлоте",
  "units.heatingDegreeDays": "Дневни степени загревања",
  "units.heatingPower": "Снага загревања",
  "units.humidex": "Humidex",
  "units.humidity": "Влажност",
  "units.inch": "Инчи",
  "units.inchOfMercury": "Инчи живиног стуба",
  "units.kilometerPerHour": "Километри на сат",
  "units.knot": "Чворови",
  "units.last12Hours": "Последњих 12 сати",
  "units.last24Hours": "Последња 24 сата",
  "units.last3Hours": "Последња 3 сата",
  "units.last6Hours": "Последњих 6 сати",
  "units.lastHour": "Последњи сат",
  "units.lastLightningImpact": "Последњи удар",
  "units.lastMeasure": "Последње мерење",
  "units.leafSensors": "Сензори влажности",
  "units.leafWetness": "Влажност листова",
  "units.lightningDistance": "Удаљеност",
  "units.lightningStrikeCount": "Бројач удара муње",
  "units.lightningStrikeDistance": "Удаљеност од места удара муње",
  "units.max": "Макс.",
  "units.max_gust": "Максимални удари ветра",
  "units.max_wind": "Макс. ветар",
  "units.meterKilometer": "Метар, километар",
  "units.meterPerSecond": "Метри у секунди",
  "units.milePerHour": "Миље на сат",
  "units.millibar": "Милибари",
  "units.millimeter": "Милиметри",
  "units.millimeterOfMercury": "Милиметри живиног стуба",
  "units.min": "Мин.",
  "units.N": "С",
  "units.N_long": "север",
  "units.NE": "СИ",
  "units.NE_long": "североистоку",
  "units.NNE": "ССИ",
  "units.NNE_long": "север-североисток",
  "units.NNW": "ССЗ",
  "units.NNW_long": "север-северозапад",
  "units.noise": "Бука",
  "units.normalizedHeatingCoefficient": "Нормализовани коефицијент загревања",
  "units.NW": "СЗ",
  "units.NW_long": "северозапад",
  "units.O3": "Озон",
  "units.PM_1": "PM1",
  "units.PM_10": "PM10",
  "units.PM_2P5": "PM2.5",
  "units.precipitation": "Падавине",
  "units.pressure": "Притисак",
  "units.rain": "Киша",
  "units.rainRate": "Интензитет кише",
  "units.referenceTemperature": "Референтна температура",
  "units.relativePressure": "Релативни притисак",
  "units.S": "Ј",
  "units.S_long": "југ",
  "units.SE": "ЈИ",
  "units.SE_long": "Југоисток",
  "units.setPoint": "Почетна тачка",
  "units.snow": "Снег",
  "units.snowfall": "Снегопад",
  "units.soilMoisture": "Влажност земљишта",
  "units.soilSensors": "Подни сензори",
  "units.solarEnergy": "Соларна енергија",
  "units.solarRadiation": "Осунчаност",
  "units.speed": "Брзина",
  "units.SSE": "ЈЈИ",
  "units.SSE_long": "југ-југоисток",
  "units.SSW": "ЈЈЗ",
  "units.SSW_long": "југо-југозапад",
  "units.stableTrend": "Стабилан тренд",
  "units.sum": "Збир",
  "units.SW": "ЈЗ",
  "units.SW_long": "Соутх Вест",
  "units.temperature": "Температура",
  "units.temperatureAndHumiditySensors": "Сензори температуре/влажности",
  "units.temperatureSensors": "Сензори температуре/влажности",
  "units.thsw": "THSW",
  "units.thw": "THW",
  "units.today": "Данас",
  "units.upTrend": "Узлазни тренд",
  "units.uv": "UV",
  "units.visibility": "Видљивост",
  "units.W": "З",
  "units.W_long": "западу",
  "units.wetBulbGlobeTemperature": "Темп. влажне кугле",
  "units.wetBulbTemperature": "Темп. мокра сијалица",
  "units.wind": "Ветар",
  "units.windChill": "Винд Цхилл",
  "units.windDirection": "Смер ветра",
  "units.windRun": "ток ветра",
  "units.windRunDescription": "Путовање ветром је укупна удаљеност коју ветар пређе у одређеном временском периоду",
  "units.WNW": "ЗСЗ",
  "units.WNW_long": "запад-северозапад",
  "units.WSW": "ЗЈЗ",
  "units.WSW_long": "запад-југозапад"
}
